class FooterNewsletter {
  constructor(element) {
    this.element = element
    this.fieldMessage = this.element.querySelector('.field__response-message')
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit(event) {

    event.preventDefault()

    const jQuery = window.jQuery
    const form = this.element;
    const fieldMessage = this.fieldMessage
    const $form = jQuery(form)

    fieldMessage.innerHTML = ''

    // Convert action in to jsonp url
    let action = form.dataset.action;

    jQuery.ajax({
      type: "POST",
      url: action,
      data: {
        email: $form.find('[name=EMAIL]').val(),
        action: 'mailchimp_subscribe',
        nonce: $form.find('[name=nonce]').val(),
      },
      error: function (err) {
        form.classList.add('show-response')
        fieldMessage.innerHTML = 'An unknown error occurred.<br>Please try again later.'
      },
      success: function (data) {

        try {
          data = JSON.parse(data)

          // treat too many requests as a success
          if (data.msg.includes('too many recent')) {
            fieldMessage.innerHTML = 'Thank you for subscribing!'
            form.classList.add('show-response')
          } else {
            fieldMessage.innerHTML = data.msg
            form.classList.add('show-response')
          }
        } catch(e) {
          console.warn(e)
          form.classList.add('show-response')
          fieldMessage.innerHTML = 'An unknown error occurred.<br>Please try again later.'
        }
      }
    })
  }

  init() {
    this.element.addEventListener('submit', this.handleSubmit)
  }
}

export default FooterNewsletter
